export default __webpack_public_path__ + "static/media/beauty.840c8fc5.png";